/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  GetFnsInn200Response,
  GetFnsInn422Response,
  GetOrgByInn200Response,
  GetOrgByInn422Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetFnsInn200ResponseFromJSON,
  GetFnsInn200ResponseToJSON,
  GetFnsInn422ResponseFromJSON,
  GetFnsInn422ResponseToJSON,
  GetOrgByInn200ResponseFromJSON,
  GetOrgByInn200ResponseToJSON,
  GetOrgByInn422ResponseFromJSON,
  GetOrgByInn422ResponseToJSON,
} from '../models/index'

export interface GetFnsInnRequest {
  inn: string
}

export interface GetOrgByInnRequest {
  inn: string
}

/**
 * FnsApi - interface
 *
 * @export
 * @interface FnsApiInterface
 */
export interface FnsApiInterface {
  /**
   * Поиск организаций по ИНН в DaData (данные ФНС). Возвращает только действующие организации (статус ACTIVE). Требуется подтверждённый email.
   * @summary Организация по ИНН (ФНС)
   * @param {string} inn ИНН: 10 или 12 цифр с корректной контрольной суммой
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FnsApiInterface
   */
  getFnsInnRaw(
    requestParameters: GetFnsInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetFnsInn200Response>>

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС). Возвращает только действующие организации (статус ACTIVE). Требуется подтверждённый email.
   * Организация по ИНН (ФНС)
   */
  getFnsInn(
    requestParameters: GetFnsInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetFnsInn200Response>

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС) с признаками ликвидации: возвращает организации в любом статусе — ACTIVE, LIQUIDATING, LIQUIDATED; для каждой указаны статус и дата ликвидации. Требуется подтверждённый email.
   * @summary Организации по ИНН с признаками ликвидации
   * @param {string} inn ИНН: 10 или 12 цифр с корректной контрольной суммой
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FnsApiInterface
   */
  getOrgByInnRaw(
    requestParameters: GetOrgByInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOrgByInn200Response>>

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС) с признаками ликвидации: возвращает организации в любом статусе — ACTIVE, LIQUIDATING, LIQUIDATED; для каждой указаны статус и дата ликвидации. Требуется подтверждённый email.
   * Организации по ИНН с признаками ликвидации
   */
  getOrgByInn(
    requestParameters: GetOrgByInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOrgByInn200Response>
}

/**
 *
 */
export class FnsApi extends runtime.BaseAPI implements FnsApiInterface {
  /**
   * Поиск организаций по ИНН в DaData (данные ФНС). Возвращает только действующие организации (статус ACTIVE). Требуется подтверждённый email.
   * Организация по ИНН (ФНС)
   */
  async getFnsInnRaw(
    requestParameters: GetFnsInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetFnsInn200Response>> {
    if (requestParameters['inn'] == null) {
      throw new runtime.RequiredError(
        'inn',
        'Required parameter "inn" was null or undefined when calling getFnsInn().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['inn'] != null) {
      queryParameters['inn'] = requestParameters['inn']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/fns-inn`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetFnsInn200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС). Возвращает только действующие организации (статус ACTIVE). Требуется подтверждённый email.
   * Организация по ИНН (ФНС)
   */
  async getFnsInn(
    requestParameters: GetFnsInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetFnsInn200Response> {
    const response = await this.getFnsInnRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС) с признаками ликвидации: возвращает организации в любом статусе — ACTIVE, LIQUIDATING, LIQUIDATED; для каждой указаны статус и дата ликвидации. Требуется подтверждённый email.
   * Организации по ИНН с признаками ликвидации
   */
  async getOrgByInnRaw(
    requestParameters: GetOrgByInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOrgByInn200Response>> {
    if (requestParameters['inn'] == null) {
      throw new runtime.RequiredError(
        'inn',
        'Required parameter "inn" was null or undefined when calling getOrgByInn().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['inn'] != null) {
      queryParameters['inn'] = requestParameters['inn']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/get-org-by-inn`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetOrgByInn200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск организаций по ИНН в DaData (данные ФНС) с признаками ликвидации: возвращает организации в любом статусе — ACTIVE, LIQUIDATING, LIQUIDATED; для каждой указаны статус и дата ликвидации. Требуется подтверждённый email.
   * Организации по ИНН с признаками ликвидации
   */
  async getOrgByInn(
    requestParameters: GetOrgByInnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOrgByInn200Response> {
    const response = await this.getOrgByInnRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
